import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllAuth } from "../../../../../actions/courses.actions";
import { CourseDto } from "@/data/dtos/course.dto";
import CourseTable from "@/components/auth/admin/courses/CourseTable";
import CreateCourseCard from "@/components/auth/admin/courses/CreateCourseCard";
import { CourseStatus } from "@/data/enums/course-status.enum";

export default function CourseList() {
  const dispatch = useDispatch();
  const allCourses = useSelector((state: any) => state.courses);
  const { user } = useSelector((state: any) => state.auth);
  const [coursesByInstructor, setCoursesByInstructor] = useState([]);

  useEffect(() => {
    console.log("useEffect 1");
    if (allCourses.listStatus === "idle") {
      dispatch(getAllAuth() as any);
    }
    if (allCourses?.courses?.length > 0) {
      if (user.role === "teacher") {
        const courses = allCourses?.courses?.filter((course) =>
          course?.instructors.some((instructor: any) =>
            instructor._id
              ? instructor._id === user._id
              : instructor === user._id
          )
        );
        setCoursesByInstructor(courses);
      }
    }
  }, [dispatch, allCourses, user._id, user.role]);

  if (coursesByInstructor.length > 0) {
    const rows = coursesByInstructor.map((item: CourseDto, index) => ({
      id: item._id,
      no: index + 1, // Her satıra benzersiz bir ID
      title: item.title,
      saleStart: item.startDate,
      level: item.level,
      price: item.price,
      discount: item.price * (item.discountPercentage / 100),
      tax: item.tax,
      status: item.status,
      isOnSale: item.isOnSale,
      thumbnail: item.images?.[0].url,
      categories: item.categories,
    }));

    return <CourseTable tableTitle="Atölyelerim" data={rows} />;
  }
  return <CreateCourseCard title="Atölye bulunamadı" cta="Atölye Ekle" />;
}
